import { SOGetRelationshipAttribute } from '../relationship-attribute/so-get-relationship-attribute';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {ENAttributePermissionType} from '../../enums';


export class SOPostRelationshipAttributePermission {

  constructor(
    public name: string,
    public whiteList: boolean,
    public permissionType: ENAttributePermissionType,
    public project: SOGetProject,
    public organization: SOGetOrganization,
    public description: string = "",
    public relationshipAttribute: SOGetRelationshipAttribute = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostRelationshipAttributePermission(
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'whiteList' in params ? params.whiteList : null,
      'permissionType' in params ? params.permissionType : null,
      'relationshipAttribute' in params ? params.relationshipAttribute : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
